import React from "react";
import {css} from "@panda/css";
import cns from "classnames";

import {DsTooltip} from "@pg-design/floating-module";
import * as classNames from "@pg-design/floating-module/src/components/DsTooltip.module.css";
import {InfoIcon} from "@pg-design/icons-module";
import {Message} from "@pg-design/message-module";
import {Highlight, Text} from "@pg-design/text-module";
import {numberFormat} from "@pg-mono/string-utils";

import {DEFAULT_INTEREST} from "../../../credit_calculator/constants/calculations_defaults";
import {creditContributionDefault} from "../../../credit_calculator/constants/credit_contribution_default";
import {creditPeriodDefault} from "../../../credit_calculator/constants/credit_period_default";
import {calculateInstallment} from "../../../credit_calculator/utils/calculate_installment";
import {convertInterestToText} from "../../../credit_calculator/utils/convert_interest_to_text";
import {ISpace} from "./PropertyDetailAdditionalSpaces";

interface IProps {
    additionalSpaces: ISpace[];
}

export const PropertyAdditionalSpacesSummary = ({additionalSpaces}: IProps) => {
    const getTotalPrice = () => {
        return additionalSpaces.reduce((acc, space) => {
            // Zakładamy, że może się zdarzyć, że będzie obiekt mający zarówno cenę, jak i is_included_in_price === true. W takim przypadku traktujemy is_included_in_price jako warunek ważniejszy od ceny.
            if (space.selected && space.price && !space.is_included_in_price) {
                acc += space.price;
            }
            return acc;
        }, 0);
    };

    const calculatedInstallment = calculateInstallment(getTotalPrice(), creditContributionDefault, creditPeriodDefault);
    const popoverContent = (
        <Message type="info" className={cns(classNames.message)}>
            <Text variant="info_txt_1">
                Kalkulator wylicza orientacyjną ratę Twojego kredytu przy założeniu, że{" "}
                <strong>średnie oprocentowanie kredytu wraz z WIBOR i marżą banku wynosi {convertInterestToText(DEFAULT_INTEREST)}.</strong>
            </Text>
        </Message>
    );

    return (
        <div className={summaryStyle}>
            <div className={summaryRowStyle}>
                <Text variant="body_copy_2">Suma:</Text>
                <Price amount={getTotalPrice()} />
            </div>
            <div className={dividerStyle} />
            <div className={summaryRowStyle}>
                <div className={tooltipWrapperStyle}>
                    <DsTooltip popover={popoverContent} type="info" zIndex={1000}>
                        {({refs, getReferenceProps}) => (
                            <InfoIcon size="1.6" wrapperSize="1.6" wrapperColor="transparent" ref={refs.setReference} {...getReferenceProps()} />
                        )}
                    </DsTooltip>
                    <Text variant="body_copy_2">Estymowana rata kredytu:</Text>
                </div>
                {calculatedInstallment && <Price amount={calculatedInstallment} />}
            </div>
        </div>
    );
};

const Price = ({amount}: {amount: number}) => (
    <span className={priceStyle}>
        <Text variant="headline_4">
            <Highlight>{numberFormat(amount)}&nbsp;</Highlight>
        </Text>
        <Text variant="body_copy_2">
            <Highlight>zł</Highlight>
        </Text>
    </span>
);

const summaryStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    padding: "0.8rem 1.6rem"
});

const summaryRowStyle = css({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
});

const dividerStyle = css({
    width: "100%",
    height: "1px",
    backgroundColor: "var(--colors-gray-200)"
});

const tooltipWrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 0.5
});

const priceStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end"
});
import React from "react";
import {css} from "@panda/css";
import cns from "classnames";

import {DsTooltip} from "@pg-design/floating-module";
import * as classNames from "@pg-design/floating-module/src/components/DsTooltip.module.css";
import {InfoIcon} from "@pg-design/icons-module";
import {Message} from "@pg-design/message-module";
import {Highlight, Text} from "@pg-design/text-module";
import {numberFormat} from "@pg-mono/string-utils";

import {DEFAULT_INTEREST} from "../../../credit_calculator/constants/calculations_defaults";
import {creditContributionDefault} from "../../../credit_calculator/constants/credit_contribution_default";
import {creditPeriodDefault} from "../../../credit_calculator/constants/credit_period_default";
import {calculateInstallment} from "../../../credit_calculator/utils/calculate_installment";
import {convertInterestToText} from "../../../credit_calculator/utils/convert_interest_to_text";
import {ISpace} from "./PropertyDetailAdditionalSpaces";

interface IProps {
    additionalSpaces: ISpace[];
}

export const PropertyAdditionalSpacesSummary = ({additionalSpaces}: IProps) => {
    const getTotalPrice = () => {
        return additionalSpaces.reduce((acc, space) => {
            // Zakładamy, że może się zdarzyć, że będzie obiekt mający zarówno cenę, jak i is_included_in_price === true. W takim przypadku traktujemy is_included_in_price jako warunek ważniejszy od ceny.
            if (space.selected && space.price && !space.is_included_in_price) {
                acc += space.price;
            }
            return acc;
        }, 0);
    };

    const calculatedInstallment = calculateInstallment(getTotalPrice(), creditContributionDefault, creditPeriodDefault);
    const popoverContent = (
        <Message type="info" className={cns(classNames.message)}>
            <Text variant="info_txt_1">
                Kalkulator wylicza orientacyjną ratę Twojego kredytu przy założeniu, że{" "}
                <strong>średnie oprocentowanie kredytu wraz z WIBOR i marżą banku wynosi {convertInterestToText(DEFAULT_INTEREST)}.</strong>
            </Text>
        </Message>
    );

    return (
        <div className={summaryStyle}>
            <div className={summaryRowStyle}>
                <Text variant="body_copy_2">Suma:</Text>
                <Price amount={getTotalPrice()} />
            </div>
            <div className={dividerStyle} />
            <div className={summaryRowStyle}>
                <div className={tooltipWrapperStyle}>
                    <DsTooltip popover={popoverContent} type="info" zIndex={1000}>
                        {({refs, getReferenceProps}) => (
                            <InfoIcon size="1.6" wrapperSize="1.6" wrapperColor="transparent" ref={refs.setReference} {...getReferenceProps()} />
                        )}
                    </DsTooltip>
                    <Text variant="body_copy_2">Estymowana rata kredytu:</Text>
                </div>
                {calculatedInstallment && <Price amount={calculatedInstallment} />}
            </div>
        </div>
    );
};

const Price = ({amount}: {amount: number}) => (
    <span className={priceStyle}>
        <Text variant="headline_4">
            <Highlight>{numberFormat(amount)}&nbsp;</Highlight>
        </Text>
        <Text variant="body_copy_2">
            <Highlight>zł</Highlight>
        </Text>
    </span>
);

const summaryStyle = css({
    display: "flex",
    flexDirection: "column",
    gap: 1,
    padding: "0.8rem 1.6rem"
});

const summaryRowStyle = css({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between"
});

const dividerStyle = css({
    width: "100%",
    height: "1px",
    backgroundColor: "var(--colors-gray-200)"
});

const tooltipWrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: 0.5
});

const priceStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end"
});
